import React from 'react';
import { pluralizer } from './utils/utils';
import PrintSizeSelector from './print-size-selector';

export default function DesktopLoaderFooter({
  files,
  brokenPreviews,
  addPhotosDisabled,
  handleAddPhotosClick,
  onCancelClick,
  onErrorIconClick,
}) {
  return (
    <div className="d-flex flex-nowrap justify-content-between buttons mx-sm-3 mx-md-3 mx-lg-0 mt-lg-2">
      <div className="d-md-flex flex-shrink-1 mr-2 mr-md-0">
        <p className="selected-images-number m-0">
          {pluralizer(files.length, 'photo')} selected
        </p>
        {brokenPreviews.length > 0 && (
          <button
            className="btn btn-link ml-md-2 mb-0 h-auto errors-link"
            onClick={onErrorIconClick}>
            {pluralizer(brokenPreviews.length, 'error')}
            <span className="fa-stack text-dark icon ml-1">
              <i className="far fa-circle fa-stack-2x p-0" />
              <i className="fas fa-exclamation fa-stack-1x  p-0" />
            </span>
          </button>
        )}
      </div>
      <PrintSizeSelector />
      <div className="d-flex flex-shrink-1">
        <button
          aria-label="Cancel"
          className="btn border-0 bg-white mb-0 py-0 cancel"
          data-dismiss="modal"
          type="button"
          onClick={onCancelClick}>
          Cancel
        </button>
        <button
          aria-label="Add photos"
          className="btn btn-primary btn-md-long action mb-0 font-weight-bold"
          disabled={addPhotosDisabled || !files.length}
          type="button"
          onClick={handleAddPhotosClick}>
          Add
        </button>
      </div>
    </div>
  );
}
